var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSaveAs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24487 0.180664C0.617836 0.180664 0.115082 0.689067 0.115082 1.31045V9.21894C0.115082 9.84032 0.617836 10.3487 1.24487 10.3487H5.65668C5.45332 9.99849 5.31209 9.61437 5.2443 9.21894H1.24487V1.31045H7.55471L9.15336 2.90909V5.30989C9.54879 5.37767 9.93291 5.5189 10.2831 5.72226V2.44023L8.02358 0.180664H1.24487ZM1.80976 1.87534V4.13491H6.89379V1.87534H1.80976ZM5.19911 5.2647C4.26139 5.2647 3.50444 6.02165 3.50444 6.95937C3.50444 7.89709 4.26139 8.65405 5.19911 8.65405C5.19911 7.5864 5.70187 6.58654 6.54921 5.94822C6.24416 5.54714 5.76401 5.2647 5.19911 5.2647ZM8.02358 6.39448V8.08916H6.3289V9.21894H8.02358V10.9136H9.15336V9.21894H10.848V8.08916H9.15336V6.39448H8.02358Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSaveAs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/save_as.f70a9e5a.svg";
export { ForwardRef as ReactComponent };